import { Checkbox } from 'src/components/atoms';
import { StyledWrapper } from './CheckboxCell.styled';
import { useTableCheckbox } from './useTableCheckbox';
import { ALL_TABLE_ROWS_VALUE } from './constant';

export const HeaderCheckboxCell = () => {
  const { isChecked, handleChange } = useTableCheckbox(ALL_TABLE_ROWS_VALUE);

  return (
    <StyledWrapper>
      <Checkbox checked={isChecked} onChange={handleChange} />
    </StyledWrapper>
  );
};
